import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import {
  NUMBER_FIELD_ALIGNS,
  NUMBER_FIELD_LAYOUTS,
  NUMBER_FIELD_VARIANTS,
} from "./constants";

export const numberFieldDataSchema = z.object({
  name: z.string().optional(),
  value: z.coerce.number().optional(),
  min: z.coerce.number().optional(),
  max: z.coerce.number().optional(),
  step: z.coerce.number().optional(),
  size: z.enum(SIZES).optional(),
  variant: z.enum(NUMBER_FIELD_VARIANTS).optional(),
  layout: z.enum(NUMBER_FIELD_LAYOUTS).optional(),
  align: z.enum(NUMBER_FIELD_ALIGNS).optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  required: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  readOnly: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type NumberFieldDataProps = z.infer<typeof numberFieldDataSchema>;
